<template>
  <FormulateForm
    :name="formName"
    v-model="formValues"
    @submit="submit"
    #default="{ isLoading }"
    class="bg-gray-200 py-4 px-6"
  >
    <h3 v-if="!edit" class="font-bold text-xl mb-4">
      New export
    </h3>

    <FormulateInput
      name="name"
      type="text"
      label="Name"
      placeholder="Name"
      validation="required"
    />
    <FormulateInput
      name="export_target"
      type="select"
      label="Export Target"
      validation-name="Export Target"
      :placeholder="
        noTargetOptions ? 'No Targets available' : 'Choose a Target'
      "
      :option-groups="targetOptions"
      validation="required"
    />

    <admin-segment-export-mapping
      :target="chosenTarget"
      @change="mapping = $event"
      class="mt-8 mb-6"
    />

    <FormulateErrors />

    <base-button type="submit" :loading="isLoading">
      {{ edit ? 'Save' : 'Create' }}
    </base-button>
  </FormulateForm>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AdminSegmentExportMapping from './AdminSegmentExportMapping.vue';
import { mappingFromForm } from '../services/mappingFromForm';

export default {
  components: { AdminSegmentExportMapping },
  props: {
    exportItem: Object,
  },
  data() {
    return {
      formName: `exportItem${this.exportItem ? this.exportItem.id : ''}`,
      formValues: this.exportItem
        ? {
            ...this.exportItem,
            export_target: this.exportItem.export_target.id,
          }
        : {},
      mapping: [],
    };
  },
  computed: {
    ...mapState({
      clients: (state) => state.company.exports.clients,
      targets: (state) => state.company.exports.targets,
      exportList: (state) => state.company.segment.exports.list,
    }),
    targetOptions() {
      const options = {};
      this.targets.forEach((target) => {
        const usedTarget = this.exportList.find(
          (e) => e.export_target.id === target.id
        );

        if (usedTarget) {
          if (!this.chosenTarget) {
            return;
          }
          const isChosenTarget =
            this.chosenTarget.id === usedTarget.export_target.id;

          if (!isChosenTarget) {
            return;
          }
        }

        const client = this.clients.find((c) => c.id === target.export_client);
        if (options[client.name]) {
          options[client.name][target.id] = target.identifier;
        } else {
          options[client.name] = {
            [target.id]: target.identifier,
          };
        }
      });
      return options;
    },
    noTargetOptions() {
      return Object.keys(this.targetOptions).length === 0;
    },
    chosenTarget() {
      return this.targets.find(
        (t) => t.id === Number(this.formValues.export_target)
      );
    },
    edit() {
      return Boolean(this.exportItem);
    },
  },
  methods: {
    ...mapActions('company/segment/exports', ['updateExport', 'addExport']),
    async submit(data) {
      try {
        const mapping = mappingFromForm(this.mapping);
        this.$formulate.resetValidation(this.formName);
        if (this.edit) {
          await this.updateExport({ exportItem: data, mapping });
        } else {
          await this.addExport({ exportItem: data, mapping });
        }
        this.$emit('saved');
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      }
    },
  },
};
</script>
